import { render, staticRenderFns } from "./vaccine.vue?vue&type=template&id=3b008e02&scoped=true&"
import script from "./vaccine.vue?vue&type=script&lang=js&"
export * from "./vaccine.vue?vue&type=script&lang=js&"
import style0 from "./vaccine.vue?vue&type=style&index=0&id=3b008e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b008e02",
  null
  
)

export default component.exports